import React from 'react';
import { Link } from 'react-router-dom';

const HERO_IMAGE_URL = '/Images/warehouse-fba-prep-hero.jpg';


const PREP_PROCESS_STEPS = [
  {
    title: 'Product inspections',
    desc: 'Quality checks to keep you Amazon-compliant',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
        <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
        <path d="M9 14h6"></path>
        <path d="M9 18h6"></path>
        <path d="M9 10h.01"></path>
      </svg>
    )
  },
  {
    title: 'FNSKU labelling',
    desc: 'Accurate and efficient labelling',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 5h2v14H3z"></path>
        <path d="M8 5h1v14H8z"></path>
        <path d="M12 5h2v14h-2z"></path>
        <path d="M17 5h1v14h-1z"></path>
        <path d="M21 5h1v14h-1z"></path>
      </svg>
    )
  },
  {
    title: 'Polybagging & bundling',
    desc: 'Customised to your product requirements',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
        <line x1="3" y1="6" x2="21" y2="6"></line>
        <path d="M16 10a4 4 0 0 1-8 0"></path>
      </svg>
    )
  },
  {
    title: 'Pallet preparation',
    desc: 'Shipment-ready pallets and compliant docs',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
        <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
        <line x1="12" y1="22.08" x2="12" y2="12"></line>
      </svg>
    )
  },
  {
    title: 'Shipment forwarding',
    desc: 'To Amazon fulfilment centres nationwide',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="1" y="3" width="15" height="13"></rect>
        <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon>
        <circle cx="5.5" cy="18.5" r="2.5"></circle>
        <circle cx="18.5" cy="18.5" r="2.5"></circle>
      </svg>
    )
  }
];

const styles = `
.ppp-fba-section {
  position: relative;
  background: #ffffff;
  overflow: hidden;
  padding: 50px 0 70px;
  border-top: 1px solid rgba(40, 71, 158, 0.12);
  border-bottom: 1px solid rgba(40, 71, 158, 0.12);
}

.ppp-fba-container {
  max-width: 1320px;
  margin: 0 auto;
  padding: 0 32px;
}

.ppp-fba-hero {
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
  min-height: 580px;
  align-items: stretch;
}

/* ---------- Left Column ---------- */
.ppp-fba-left {
  padding: 10px 0 20px;
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.ppp-fba-eyebrow {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 1.5px;
  color: #64748B;
  text-transform: uppercase;
  margin-bottom: 20px;
}

.ppp-fba-eyebrow-line {
  width: 24px;
  height: 2px;
  background: #F68C43;
  flex-shrink: 0;
}

.ppp-fba-title {
  margin-top: 20px;
  font-size: 50px;
  line-height: 1.1;
  font-weight: 800;
  letter-spacing: -1.2px;
  color: #0b1f4b;
}

.ppp-fba-title .blue {
  color: #1A44E5;
}

.ppp-fba-title .dot {
  color: #ff8c1a;
}

.ppp-fba-desc {
  margin-top: 20px;
  font-size: 16px;
  line-height: 1.65;
  color: #5b6478;
  max-width: 600px;
}

.ppp-fba-inline-link {
  color: #1A44E5;
  text-decoration: underline;
  text-underline-offset: 3px;
  font-weight: 600;
  transition: color 0.15s ease;
}

.ppp-fba-inline-link:hover {
  color: #1234B5;
}

.ppp-fba-footer-note {
  margin-top: 18px;
  font-size: 15.5px;
  line-height: 1.65;
  color: #5b6478;
  max-width: 600px;
}

/* ---------- Right Column ---------- */
.ppp-fba-right {
  position: relative;
  min-height: 520px;
  display: flex;
  flex-direction: column;
}

.ppp-fba-bg-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 380px;
  border-radius: 32px 32px 90px 32px;
  overflow: hidden;
  box-shadow: 0 16px 36px rgba(11, 31, 75, 0.14);
  background: #0f1f3d;
}

.ppp-fba-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
}

.ppp-fba-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(15, 31, 61, 0.15) 0%, rgba(10, 23, 48, 0.55) 100%);
}

.ppp-fba-swoosh {
  position: absolute;
  right: -45px;
  top: 15%;
  width: 200px;
  height: 240px;
  border-radius: 50%;
  border: 45px solid rgba(255, 140, 26, 0.75);
  border-left-color: transparent;
  border-bottom-color: transparent;
  transform: rotate(-20deg);
  opacity: 0.85;
  pointer-events: none;
  z-index: 2;
}

/* Floating info card (compact & small) */
.ppp-fba-card {
  position: relative;
  margin: 12px 16px 0 auto;
  width: calc(100% - 32px);
  max-width: 350px;
  background: #ffffff;
  border-radius: 14px;
  padding: 14px 16px 16px;
  box-shadow: 0 12px 32px rgba(11, 31, 75, 0.18);
  z-index: 4;
  border: 1px solid rgba(40, 71, 158, 0.08);
}

.ppp-fba-card-tag {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 10px;
  letter-spacing: 1.2px;
  color: #ff8c1a;
  font-weight: 700;
  text-transform: uppercase;
}

.ppp-fba-pin {
  font-size: 13px;
}

.ppp-fba-card h3 {
  margin: 6px 0 0;
  font-size: 17px;
  color: #0b1f4b;
  font-weight: 800;
  line-height: 1.25;
}

.ppp-fba-card p {
  margin: 6px 0 0;
  font-size: 12px;
  line-height: 1.5;
  color: #5b6478;
}

.ppp-fba-card p a {
  color: #1f6fff;
  font-weight: 600;
  text-decoration: underline;
}

.ppp-fba-card p a:hover {
  color: #0e4ed8;
}

.ppp-fba-card-btn {
  margin-top: 12px;
  width: 100%;
  background: #1A44E5;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 9px 14px;
  font-size: 12.5px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  transition: transform 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
  box-shadow: 0 4px 14px rgba(26, 68, 229, 0.25);
}

.ppp-fba-card-btn:hover {
  background: #1234B5;
  transform: translateY(-2px);
  box-shadow: 0 10px 24px rgba(26, 68, 229, 0.38);
  color: #ffffff;
}

/* ---------- Replaced Process Cards Row (overlaps bottom half of image) ---------- */
.ppp-fba-process {
  position: relative;
  margin-top: 40px;
  z-index: 5;
  display: flex;
  justify-content: center;
}

.ppp-fba-steps {
  display: flex;
  align-items: stretch;
  gap: 8px;
  width: 100%;
  justify-content: space-between;
}

.ppp-fba-step-card {
  flex: 1;
  min-width: 0;
  background: #ffffff;
  border-radius: 12px;
  padding: 12px 10px 14px;
  box-shadow: 0 10px 25px rgba(11, 31, 75, 0.12);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  border: 1px solid rgba(40, 71, 158, 0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.ppp-fba-step-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 14px 30px rgba(11, 31, 75, 0.18);
}

.ppp-fba-step-icon {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: #eef2ff;
  color: #1A44E5;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  flex-shrink: 0;
}

.ppp-fba-step-title {
  font-size: 12px;
  font-weight: 700;
  color: #0b1f4b;
  margin: 0 0 4px 0;
  line-height: 1.25;
}

.ppp-fba-step-desc {
  font-size: 10px;
  color: #64748b;
  margin: 0;
  line-height: 1.35;
  font-weight: 500;
}

.ppp-fba-step-arrow {
  color: #1A44E5;
  font-size: 16px;
  font-weight: 800;
  display: flex;
  align-items: center;
  padding: 0 2px;
  flex-shrink: 0;
}

/* ---------- Responsive ---------- */
@media (max-width: 1100px) {
  .ppp-fba-hero {
    grid-template-columns: 1fr;
    gap: 36px;
  }
  .ppp-fba-left {
    padding: 10px 0;
  }
  .ppp-fba-title {
    font-size: 40px;
  }
  .ppp-fba-right {
    min-height: 620px;
  }
  .ppp-fba-card {
    margin: 16px auto 0;
    max-width: 90%;
  }
  .ppp-fba-process {
    overflow-x: auto;
    padding-bottom: 8px;
    justify-content: flex-start;
  }
  .ppp-fba-step-card {
    min-width: 130px;
  }
}

@media (max-width: 640px) {
  .ppp-fba-section {
    padding: 36px 0 50px;
  }
  .ppp-fba-container {
    padding: 0 16px;
  }
  .ppp-fba-title {
    font-size: 32px;
  }
  .ppp-fba-step-card {
    min-width: 120px;
  }
  .ppp-fba-step-arrow {
    display: none;
  }
}
`;

export default function SfpComparisonSection() {
  return (
    <>
      <style>{styles}</style>
      <section className="ppp-fba-section" aria-labelledby="sfp-compare-heading">
        <div className="ppp-fba-container">
          <div className="ppp-fba-hero">
            
            {/* Left Column */}
            <div className="ppp-fba-left">
              <div className="ppp-fba-eyebrow">
                <span className="ppp-fba-eyebrow-line" />
                Amazon FBA Prep
              </div>

              <h2 id="sfp-compare-heading" className="ppp-fba-title">
                Amazon FBA Prep<br />
                Built for Growing<br />
                <span className="blue">E-Commerce Brands</span>
              </h2>

              <p className="ppp-fba-desc">
                Managing Amazon FBA operations in-house can slow growth and increase costs. Our UK prep centre supports <Link to="/amazon-fba-prep-services" className="ppp-fba-inline-link">Amazon FBA sellers</Link>, <Link to="/amazon-fba-prep-wholesale" className="ppp-fba-inline-link">wholesale sellers</Link>, and <Link to="/amazon-fba-prep-private-label" className="ppp-fba-inline-link">private label brands</Link> with product inspections, FNSKU labelling, polybagging, bundling, pallet preparation, and shipment forwarding. Operating from our Milton Keynes fulfilment centre, we help sellers stay Amazon-compliant while moving inventory quickly into fulfilment centres nationwide.
              </p>

              <p className="ppp-fba-footer-note">
                Whether you’re scaling <Link to="/shopify-fulfillment-services" className="ppp-fba-inline-link">Shopify stores</Link>, <Link to="/tiktok-live-sales-fulfillment" className="ppp-fba-inline-link">TikTok Shop brands</Link>, or <Link to="/multi-channel-fulfillment-services" className="ppp-fba-inline-link">multi-channel E-Commerce businesses</Link>, our experienced warehouse team provides flexible, scalable E-Commerce fulfilment solutions sending inventory into <Link to="/amazon-fba-prep-services" className="ppp-fba-inline-link">Amazon fulfilment centres</Link> and fulfilling direct-to-consumer orders tailored to growing online brands across the UK.
              </p>
            </div>

            {/* Right Column */}
            <div className="ppp-fba-right">
              {/* Background Warehouse Image with half height */}
              <div className="ppp-fba-bg-wrapper">
                <img
                  src={HERO_IMAGE_URL}
                  alt="Amazon FBA Prep Warehouse - Pick Pack Pro"
                  className="ppp-fba-img"
                  loading="lazy"
                />
                <div className="ppp-fba-overlay" />
              </div>

              <div className="ppp-fba-swoosh" aria-hidden="true" />

              {/* Floating Info Card (Upar position kiya gaya) */}
              <aside className="ppp-fba-card" aria-labelledby="fba-prep-centre-heading">
                <div className="ppp-fba-card-tag">
                  <span className="ppp-fba-pin" aria-hidden="true">📍</span>
                  UK FBA Prep Centre
                </div>

                <h3 id="fba-prep-centre-heading">Amazon FBA Prep Centre UK</h3>

                <p>
                  Pick Pack Pro is a UK-based{' '}
                  <Link to="/amazon-fba-prep-centre-services">Amazon FBA prep centre</Link> providing prep,
                  storage, pick and pack, and E-Commerce fulfilment services for online sellers nationwide.
                  Whether you need{' '}
                  <Link to="/amazon-fba-prep-services">Amazon prep services</Link>,{' '}
                  <Link to="/logistics-services">pallet forwarding</Link>,{' '}
                  <Link to="/amazon-fba-shipments">shipment creation</Link>, or a reliable{' '}
                  <Link to="/our-fulfilment-center">3PL warehouse partner</Link>, our team helps
                  streamline your fulfilment operations.
                </p>

                <Link to="/amazon-fba-prep-centre-services" className="ppp-fba-card-btn">
                  View prep centre services <span>→</span>
                </Link>
              </aside>

              {/* Process Steps Strip (Aapke bataye huye 5 clean icon + title + description cards) */}
              <div className="ppp-fba-process">
                <div className="ppp-fba-steps">
                  {PREP_PROCESS_STEPS.map((step, i) => (
                    <React.Fragment key={step.title}>
                      <div className="ppp-fba-step-card">
                        <div className="ppp-fba-step-icon">{step.icon}</div>
                        <h4 className="ppp-fba-step-title">{step.title}</h4>
                        <p className="ppp-fba-step-desc">{step.desc}</p>
                      </div>
                      {i < PREP_PROCESS_STEPS.length - 1 && (
                        <span className="ppp-fba-step-arrow" aria-hidden="true">→</span>
                      )}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
}
